import GameAssignmentDeleteConfirmPopup from "./GameAssignmentDeleteConfirmPopup";

export default GameAssignmentDeleteConfirmPopup;